export const vendorKeys = {
  all: ['vendors'] as const,

  statusRoot: () => [...vendorKeys.all, 'status'] as const,
  status: (userId: string | null | undefined) => [...vendorKeys.statusRoot(), userId ?? 'anon'] as const,

  admin: () => [...vendorKeys.all, 'admin'] as const,
  adminVendors: (type?: string) => [...vendorKeys.admin(), 'vendors', { type: type ?? 'all' }] as const,
  adminDefault: () => [...vendorKeys.admin(), 'default'] as const,

  portal: () => [...vendorKeys.all, 'portal'] as const,
  vendorClaims: () => [...vendorKeys.portal(), 'claims'] as const,
  vendorClaimDocuments: (claimId: string) => [...vendorKeys.portal(), 'claim', claimId, 'documents'] as const,
  vendorClaimDetail: (claimId: string) => [...vendorKeys.portal(), 'claim', claimId] as const,

  member: () => [...vendorKeys.all, 'member'] as const,
  claimPublicAdjuster: (claimId: string) => [...vendorKeys.member(), 'claim', claimId, 'public-adjuster'] as const,
} as const
